module.exports = __webpack_public_path__ + "static/media/26UNRWA8.b6a531df.jpg";